import { css } from 'styled-components';

import { pickColor } from 'themes/helpers/pickColor';
import { mediaMinWidth } from 'themes/mixins/mediaQueries';

const motives = {
  m1: css`
    flex-direction: column;

    input {
      width: 100%;
      height: 3.6rem;
      padding: 0.6rem 1.2rem;

      color: ${pickColor('black')};
      background-color: ${pickColor('white')};
      border: 0.1rem solid ${pickColor('borderLight')};

      font-weight: lighter;

      &:disabled {
        color: ${pickColor('grayDark')};
      }
    }

    label {
      height: 1.9rem;
      margin: 1rem 0;

      text-transform: uppercase;

      font-weight: 600;
      letter-spacing: 0.1rem;

      color: ${pickColor('grayLabel')};

      ${mediaMinWidth.md(css`
        margin-bottom: 1.6rem;
      `)}
    }
  `,
  m2: css`
    flex-direction: row;
    align-items: center;

    label {
      height: 1.9rem;
      margin: 1rem 0;
      padding-right: 5rem;

      text-transform: uppercase;

      font-weight: 600;
      letter-spacing: 0.1rem;

      color: ${pickColor('grayLabel')};

      white-space: nowrap;
    }

    input {
      width: 100%;

      color: ${pickColor('grayDark')};
      background-color: ${pickColor('white')};
      border: 0.1rem solid ${pickColor('borderLight')};
      border-radius: ${({ theme }) => theme.borderRadius.base};
    }
  `,
  login: css`
    flex-direction: column;

    label {
      margin-bottom: 0.4rem;

      font-weight: 700;
      font-family: 'LFT Zeno', sans-serif;
      font-size: 1.2rem;

      text-transform: capitalize;
    }

    input {
      padding: 1.4rem 1.9rem;

      border: 0.1rem solid ${pickColor('black')};
      border-radius: ${({ theme }) => theme.borderRadius.base};

      font-size: 1.2rem;
    }
  `,
  filter: css`
    flex-direction: column;

    label {
      margin-bottom: 0.4rem;

      font-family: 'LFT Zeno', sans-serif;
      font-size: 1.2rem;
      font-weight: 600;
    }

    input {
      font-size: 1.2rem;

      padding: 0.8rem;
      height: 3.6rem;

      border: 0.1rem solid ${pickColor('borderColorDarkSecondary')};
      border-radius: ${({ theme }) => theme.borderRadius.base};

      color: ${pickColor('black')};
    }
  `,
  additional: css`
    flex: 1;

    label {
      margin: 0.4rem 0;
      padding-left: 1.5rem;

      color: ${pickColor('grayDark')};

      font-family: 'LFT Zeno Condensed', sans-serif;
      font-size: 1.2rem;
      font-weight: lighter;

      text-transform: uppercase;

      letter-spacing: 0.1rem;
    }

    input {
      padding: 0.8rem;
      height: 3.6rem;

      border: 0.1rem solid ${pickColor('borderColorDarkSecondary')};
      border-radius: ${({ theme }) => theme.borderRadius.base};

      color: ${pickColor('black')};
    }
  `,
  additionalSecondary: css`
    flex: 1;
    align-items: center;

    label {
      margin: 0.4rem 10rem 0.4rem 0;
      padding-left: 1.5rem;

      color: ${pickColor('grayDark')};

      font-family: 'LFT Zeno Condensed', sans-serif;
      font-size: 1.3rem;
      font-weight: lighter;

      text-transform: uppercase;

      letter-spacing: 0.1rem;
    }

    input {
      padding: 0.8rem;
      height: 3.6rem;

      border: 0.1rem solid ${pickColor('borderLight')};
      border-radius: ${({ theme }) => theme.borderRadius.base};

      color: ${pickColor('black')};
    }
  `,
  orderCell: css`
    input {
      width: 2.5rem;
      height: 2.5rem;
      padding-left: 0.4rem;
    }
  `,
};

export type InputMotives = keyof typeof motives;

const pickMotive = (motive: InputMotives) => motives[motive];

export { pickMotive };
